import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import LectureUpload from "./LectureUpload";
import LectureMasters from "./LectureMasters";
import LectureManage from "./LectureManage";
import "./_lectureLibrary.scss";
import { THEME, MOCK_CATEGORIES, MOCK_SUBCATEGORIES, MOCK_CLASSES, MOCK_SUBJECTS, MOCK_LECTURERS, MOCK_BRANCHES, MOCK_VIDEOS } from "./lectureLibraryConstants";
import { GET_CLASSES, GET_EMPLOYEE_DETAILS, GET_LECTURE_CATEGORIES, GET_LECTURE_SUBCATEGORIES, GET_LECTURE_VIDEOS, GET_ACADEMIC_YEARS, GET_BRANCHES } from "./lectureLibraryService";

class LectureLibraryHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editItem: null,
      loading: true,

      // Metadata configuration
      categories: [...MOCK_CATEGORIES],
      subcategories: [...MOCK_SUBCATEGORIES],
      classes: [...MOCK_CLASSES],
      subjects: [],
      lecturers: [...MOCK_LECTURERS],
      branches: [...MOCK_BRANCHES],
      videos: [...MOCK_VIDEOS],

      instituteId: 1,
      userId: 1,
      academicYearId: null,
    };
  }

  componentDidMount() {
    this.initializeData();
  }

  initializeData = async (quiet = false) => {
    const { client } = this.props;

    // Retrieve global institution and user IDs
    let instId = 1;
    if (Cookies.get("institutionid")) {
      instId = parseInt(Cookies.get("institutionid"));
    } else if (Cookies.get("institute_id")) {
      instId = parseInt(Cookies.get("institute_id"));
    }

    let userId = 1;
    if (Cookies.get("id")) {
      userId = parseInt(Cookies.get("id"));
    } else if (Cookies.get("user_id")) {
      userId = parseInt(Cookies.get("user_id"));
    }

    if (!quiet) {
      this.setState({ instituteId: instId, userId, loading: true });
    } else {
      this.setState({ instituteId: instId, userId });
    }

    try {
      // 1. Fetch Branches from API
      let branches = [];
      try {
        const branchRes = await client.query({
          query: GET_BRANCHES,
          variables: { institution_id: instId },
          fetchPolicy: "network-only",
        });
        if (branchRes.data?.getBranches?.length) {
          branches = branchRes.data.getBranches;
        }
      } catch (err) {
        console.warn("Could not query branches.", err);
      }

      // 2. Fetch Classes (Apollo GraphQL)
      let classes = [...MOCK_CLASSES];
      try {
        const classRes = await client.query({
          query: GET_CLASSES,
          variables: { id: 1 },
          fetchPolicy: "network-only",
        });
        if (classRes.data?.getExamClasses?.length) {
          classes = classRes.data.getExamClasses;
        }
      } catch (err) {
        console.warn("Could not query classes, using fallback mock classes.");
      }

      // 3. Fetch Employee Details (Lecturers)
      let lecturers = [...MOCK_LECTURERS];
      try {
        const empRes = await client.query({
          query: GET_EMPLOYEE_DETAILS,
          variables: { institute_id: instId, branch_id: 0 },
          fetchPolicy: "network-only",
        });
        if (empRes.data?.getEmployeeDetails?.length) {
          lecturers = empRes.data.getEmployeeDetails;
        }
      } catch (err) {
        console.warn("Could not query employee details, using mock lecturers.");
      }

      // 4. Fetch Video Categories
      let categories = [...MOCK_CATEGORIES];
      try {
        const catRes = await client.query({
          query: GET_LECTURE_CATEGORIES,
          variables: { institute_id: instId },
          fetchPolicy: "network-only",
        });
        if (catRes.data && Array.isArray(catRes.data.getLectureCategories)) {
          categories = catRes.data.getLectureCategories.map((c) => ({
            ...c,
            estatus: c.estatus ? 1 : 0,
          }));
        }
      } catch (err) {
        console.warn("Could not query video categories, using mock categories.");
      }

      // 5. Fetch Video Sub Categories
      let subcategories = [...MOCK_SUBCATEGORIES];
      try {
        const subRes = await client.query({
          query: GET_LECTURE_SUBCATEGORIES,
          variables: { institute_id: instId },
          fetchPolicy: "network-only",
        });
        if (subRes.data && Array.isArray(subRes.data.getLectureSubCategories)) {
          subcategories = subRes.data.getLectureSubCategories.map((s) => ({
            ...s,
            estatus: s.estatus ? 1 : 0,
          }));
        }
      } catch (err) {
        console.warn("Could not query sub categories, using mock subcategories.");
      }

      // 6. Fetch Academic Year
      let academicYearId = null;
      try {
        const acadRes = await client.query({
          query: GET_ACADEMIC_YEARS,
          variables: { id: instId },
          fetchPolicy: "network-only",
        });
        if (acadRes.data?.getAcademicYears?.length) {
          academicYearId = acadRes.data.getAcademicYears[0].id;
        }
      } catch (err) {
        console.warn("Could not query academic years.");
      }

      // Extract a flat array of mock subjects for the Dashboard filters until a global subjects query is available
      const allSubjects = [];
      const seen = new Set();
      Object.values(MOCK_SUBJECTS).forEach(arr => {
        arr.forEach(s => {
          if (!seen.has(s.id)) {
            seen.add(s.id);
            allSubjects.push(s);
          }
        });
      });

      this.setState(
        {
          branches,
          classes,
          subjects: allSubjects,
          lecturers,
          categories,
          subcategories,
          academicYearId,
        },
        this.fetchVideosList
      );
    } catch (err) {
      console.error("Initialization error", err);
      this.setState({ loading: false });
    }
  };

  fetchVideosList = async () => {
    const { client } = this.props;
    const { instituteId } = this.state;

    try {
      const res = await client.query({
        query: GET_LECTURE_VIDEOS,
        variables: { filter: { institute_id: instituteId } },
        fetchPolicy: "network-only",
      });

      if (res.data && Array.isArray(res.data.getLectureVideos)) {
        const videos = res.data.getLectureVideos.map((v) => ({
          ...v,
          paid_video: v.paid_video ? 1 : 0,
          publish: v.publish ? 1 : 0,
          estatus: v.estatus ? 1 : 0,
        }));
        this.setState({ videos, loading: false });
      } else {
        this.setState({ videos: [...MOCK_VIDEOS], loading: false });
      }
    } catch (err) {
      console.warn("Could not query videos list, using mock database list.");
      this.setState({ videos: [...MOCK_VIDEOS], loading: false });
    }
  };

  refreshMastersData = async () => {
    const { client } = this.props;
    const { instituteId } = this.state;

    try {
      let categories = this.state.categories;
      try {
        const catRes = await client.query({
          query: GET_LECTURE_CATEGORIES,
          variables: { institute_id: instituteId },
          fetchPolicy: "network-only",
        });
        if (catRes.data && Array.isArray(catRes.data.getLectureCategories)) {
          categories = catRes.data.getLectureCategories.map((c) => ({
            ...c,
            estatus: c.estatus ? 1 : 0,
          }));
        }
      } catch (err) {
        console.warn("Could not refresh video categories.", err);
      }

      let subcategories = this.state.subcategories;
      try {
        const subRes = await client.query({
          query: GET_LECTURE_SUBCATEGORIES,
          variables: { institute_id: instituteId },
          fetchPolicy: "network-only",
        });
        if (subRes.data && Array.isArray(subRes.data.getLectureSubCategories)) {
          subcategories = subRes.data.getLectureSubCategories.map((s) => ({
            ...s,
            estatus: s.estatus ? 1 : 0,
          }));
        }
      } catch (err) {
        console.warn("Could not refresh sub categories.", err);
      }

      this.setState({ categories, subcategories });
    } catch (err) {
      console.error("Refresh masters data error", err);
    }
  };

  // ─── Tab Operations ────────────────────────────────────────────────────────

  setActiveTab = (tab) => {
    // Reset editItem when leaving upload form tab
    if (tab !== "upload") {
      this.setState({ editItem: null });
    }
    this.props.history.push(`/lecture-library/${tab}`);
  };

  handleEditLecture = (item) => {
    this.setState({
      editItem: item,
    });
    this.props.history.push(`/lecture-library/upload`);
  };

  handleUploadSuccess = () => {
    this.setState({ editItem: null });
    this.props.history.push(`/lecture-library/manage`);
    this.fetchVideosList();
  };

  handleCancelForm = () => {
    this.setState({ editItem: null });
    this.props.history.push(`/lecture-library/manage`);
  };

  render() {
    const { editItem, loading, categories, subcategories, classes, subjects, lecturers, branches, videos, instituteId, userId, academicYearId } = this.state;
    const activeTab = this.props.match.params.tab || "manage";
    const { client } = this.props;

    if (loading) {
      return (
        <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px" }}>
          <Container fluid className="px-0">
            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>

              {/* Tab strip shimmer */}
              <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "16px 24px" }}>
                <div className="d-flex" style={{ gap: 12 }}>
                  <div className="ll-shimmer" style={{ width: 130, height: 38 }} />
                  <div className="ll-shimmer" style={{ width: 170, height: 38 }} />
                  <div className="ll-shimmer" style={{ width: 200, height: 38 }} />
                </div>
              </div>

              {/* Content shimmer */}
              <div style={{ padding: "28px" }}>
                {/* Filter row */}
                <div className="d-flex flex-wrap" style={{ gap: 16, marginBottom: 28 }}>
                  {[0, 1, 2, 3].map((i) => (
                    <div key={i} className="ll-shimmer" style={{ flex: "1 1 180px", height: 44 }} />
                  ))}
                </div>

                {/* Card grid */}
                <div className="d-flex flex-wrap" style={{ gap: 20 }}>
                  {[0, 1, 2, 3, 4, 5].map((i) => (
                    <div
                      key={i}
                      style={{
                        flex: "1 1 280px",
                        maxWidth: 360,
                        border: "1px solid #e2e8f0",
                        borderRadius: 12,
                        padding: 16,
                        background: "#fff",
                      }}
                    >
                      <div className="ll-shimmer" style={{ width: "100%", height: 150, marginBottom: 14 }} />
                      <div className="ll-shimmer" style={{ width: "80%", height: 16, marginBottom: 10 }} />
                      <div className="ll-shimmer" style={{ width: "55%", height: 13, marginBottom: 14 }} />
                      <div className="d-flex" style={{ gap: 10 }}>
                        <div className="ll-shimmer" style={{ width: 70, height: 24, borderRadius: 12 }} />
                        <div className="ll-shimmer" style={{ width: 70, height: 24, borderRadius: 12 }} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </Container>
        </div>
      );
    }

    const tabs = [
      { key: "manage", label: "Dashboard", icon: "fal fa-video" },
      { key: "upload", label: editItem ? "Edit Lecture Video" : "Upload Lecture Video", icon: "fal fa-upload" },
      { key: "masters", label: "Category and Sub Category", icon: "fal fa-tags" },
    ];

    return (
      <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px" }}>
        <Container fluid className="px-0">
          <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>

            {/* Unified tab navigation header strip */}
            <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
              <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.key;
                  return (
                    <li className="nav-item" key={tab.key}>
                      <a
                        className={`nav-link ${isActive ? "active" : ""}`}
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.setActiveTab(tab.key);
                        }}
                        style={{
                          cursor: "pointer",
                          fontWeight: 700,
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "12px 20px",
                          color: isActive ? "#6366f1" : "#4b5563",
                          background: isActive ? "#fff" : "transparent",
                          borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                          borderWidth: "1.5px",
                          borderBottomWidth: isActive ? "2px" : "1.5px",
                          borderRadius: "10px 10px 0 0",
                          transition: "all 0.15s ease",
                          marginBottom: "-1.5px"
                        }}
                      >
                        <i className={tab.icon} />
                        {tab.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Seamless Content Panel */}
            <div style={{ padding: "28px" }}>
              {activeTab === "manage" && (
                <LectureManage
                  client={client}
                  videos={videos}
                  categories={categories}
                  subcategories={subcategories}
                  classes={classes}
                  subjects={subjects}
                  lecturers={lecturers}
                  branches={branches}
                  instituteId={instituteId}
                  academicYearId={academicYearId}
                  onEdit={this.handleEditLecture}
                  onUpdate={this.initializeData}
                />
              )}
              {activeTab === "upload" && (
                <LectureUpload
                  client={client}
                  editItem={editItem}
                  categories={categories}
                  subcategories={subcategories}
                  classes={classes}
                  subjects={subjects}
                  lecturers={lecturers}
                  branches={branches}
                  instituteId={instituteId}
                  userId={userId}
                  academicYearId={academicYearId}
                  onSuccess={this.handleUploadSuccess}
                  onCancel={this.handleCancelForm}
                />
              )}
              {activeTab === "masters" && (
                <LectureMasters
                  client={client}
                  categories={categories}
                  subcategories={subcategories}
                  instituteId={instituteId}
                  onUpdate={this.refreshMastersData}
                />
              )}
            </div>

          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(withApollo(LectureLibraryHome));
